import {
  Alert,
  Box,
  Button,
  Code,
  Flex,
  Loader,
  Table,
  TableTbody,
  TableTd,
  TableTh,
  TableThead,
  TableTr,
} from '@mantine/core';
import { useLogPager } from '../hooks/useLogPager';
import { Date } from '../components/Date';
import { LicenseLogFilterDetails } from '../components/LicenseLogFilters';

export const LicenseLogsTable = ({
  logType,
  filters,
  setFilters,
}: {
  logType: 'licenses' | 'failures';
  filters: LicenseLogFilterDetails;
  setFilters: (filters: LicenseLogFilterDetails) => void;
}) => {
  const { data, next, prev } = useLogPager(
    logType,
    filters.dateRange[0],
    filters.dateRange[1],
    filters.forceRefresh,
    filters.app,
    filters.cursor
  );

  return (
    <Box>
      {data ? (
        data.length === 0 ? (
          <Alert>No logs found</Alert>
        ) : (
          <Box>
            <Table.ScrollContainer minWidth={500}>
              <Table>
                <TableThead>
                  <TableTr>
                    <TableTh>App</TableTh>
                    {logType === 'failures' ? <TableTh>Error</TableTh> : null}
                    <TableTh>Date</TableTh>
                    <TableTh>API Key</TableTh>
                    <TableTh>IP Address</TableTh>
                    <TableTh>Query Data</TableTh>
                    <TableTh>Extra fields</TableTh>
                  </TableTr>
                </TableThead>
                <TableTbody>
                  {data.map((log) => (
                    <TableTr key={log._id}>
                      <TableTd>{log.meta.app}</TableTd>
                      {logType === 'failures' ? (
                        <TableTd>{log.error}</TableTd>
                      ) : null}
                      <TableTd>
                        <Date isoString={log.date} />
                      </TableTd>
                      <TableTd>{log.meta.apiKey}</TableTd>
                      <TableTd>{log.meta.ip}</TableTd>
                      <TableTd>
                        <Code>{JSON.stringify(log.matchData)}</Code>
                      </TableTd>
                      <TableTd>
                        <Code>{JSON.stringify(log.extraFields)}</Code>
                      </TableTd>
                    </TableTr>
                  ))}
                </TableTbody>
              </Table>
            </Table.ScrollContainer>
            <Flex align="center" justify="space-between">
              {prev ? (
                <Button
                  onClick={() => setFilters({ ...filters, cursor: prev })}
                >
                  Previous
                </Button>
              ) : (
                <Button disabled>Previous</Button>
              )}
              {next ? (
                <Button
                  onClick={() => setFilters({ ...filters, cursor: next })}
                >
                  Next
                </Button>
              ) : (
                <Button disabled>Next</Button>
              )}
            </Flex>
          </Box>
        )
      ) : (
        <Loader />
      )}
    </Box>
  );
};
